import { Link } from 'react-router-dom';

export const NotFoundPage = (): React.JSX.Element => {
  return (
    <div className="container py-20 md:py-32 text-center">
      <div className="text-accent font-mono text-sm mb-4">404</div>
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Страница не найдена</h1>
      <p className="text-ink-300 mb-8">Возможно, она ещё не построена — мы только запускаемся.</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-md border border-ink-700 hover:border-ink-400 px-6 py-3 text-base font-medium text-ink-100 transition-colors"
      >
        ← На главную
      </Link>
    </div>
  );
};
